import { h, FunctionalComponent } from 'preact';
import SharedLocationLayout from '../shared-location-layout/shared-location-layout';
import GeneralErrorMessage from '../../components/general-error-message/general-error-message';

const ErrorPage: FunctionalComponent = () => {
	return (
		<SharedLocationLayout>
			<GeneralErrorMessage />
		</SharedLocationLayout>
	);
};

export default ErrorPage;
